var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('update-password-form',{key:_vm.refresh,attrs:{"disabled":_vm.loading,"updateMessage":_vm.updateMessage},on:{"update":_vm.updatePassword,"confirm":_vm.confirm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }